import ChangePassword from "./ChangePassword"
import EmergencyAccess from "./EmergencyAccess"
import ManageSessions from "./ManageSessions"
import MobilePasswordless from "./MobilePasswordless"
import Passkey from "./Passkey"
import SecurityKey from "./SecurityKey"
import TwoFA from "./TwoFA"
import EncryptionKeySettings from "./EncryptionKeySettings"

const securityComponents = {
  ChangePassword,
  EmergencyAccess,
  ManageSessions,
  MobilePasswordless,
  Passkey,
  SecurityKey,
  TwoFA,
  EncryptionKeySettings
}

export default securityComponents